import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Dashboard from './Dashboard';
import Home from './Home';
import useHubspotTracking from '../hooks/useHubspotTracking';

const Main = () => {
    useHubspotTracking();

    return (
        <Routes>
            <Route path={`/`} element={<Home />} />
            <Route path={`:slug/:section?`} element={<Dashboard />} />
        </Routes>
    );
};

export default Main;
